module.exports = __webpack_public_path__ + "img/shield.8ee1e05d.png";